"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentHub = void 0;
exports.getCurrentHubShim = getCurrentHubShim;

var _breadcrumbs = require("./breadcrumbs.js");

var _currentScopes = require("./currentScopes.js");

var _exports = require("./exports.js");

/**
 * This is for legacy reasons, and returns a proxy object instead of a hub to be used.
 *
 * @deprecated Use the methods directly from the top level Sentry API (e.g. `Sentry.withScope`)
 * For more information see our migration guide for
 * [replacing `getCurrentHub` and `Hub`](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 * usage
 */
// eslint-disable-next-line deprecation/deprecation
function getCurrentHubShim() {
  return {
    bindClient(client) {
      const scope = (0, _currentScopes.getCurrentScope)();
      scope.setClient(client);
    },

    withScope: _currentScopes.withScope,
    getClient: () => (0, _currentScopes.getClient)(),
    getScope: _currentScopes.getCurrentScope,
    getIsolationScope: _currentScopes.getIsolationScope,
    captureException: (exception, hint) => {
      return (0, _currentScopes.getCurrentScope)().captureException(exception, hint);
    },
    captureMessage: (message, level, hint) => {
      return (0, _currentScopes.getCurrentScope)().captureMessage(message, level, hint);
    },
    captureEvent: _exports.captureEvent,
    addBreadcrumb: _breadcrumbs.addBreadcrumb,
    setUser: _exports.setUser,
    setTags: _exports.setTags,
    setTag: _exports.setTag,
    setExtra: _exports.setExtra,
    setExtras: _exports.setExtras,
    setContext: _exports.setContext,

    getIntegration(integration) {
      const client = (0, _currentScopes.getClient)();
      return client && client.getIntegrationByName(integration.id) || null;
    },

    startSession: _exports.startSession,
    endSession: _exports.endSession,

    captureSession(end) {
      // both send the update and pull the session from the scope
      if (end) {
        return (0, _exports.endSession)();
      } // only send the update


      _sendSessionUpdate();
    }

  };
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */
// eslint-disable-next-line deprecation/deprecation


const getCurrentHub = exports.getCurrentHub = getCurrentHubShim;
/**
 * Sends the current Session on the scope
 */

function _sendSessionUpdate() {
  const scope = (0, _currentScopes.getCurrentScope)();
  const client = (0, _currentScopes.getClient)();
  const session = scope.getSession();

  if (client && session) {
    client.captureSession(session);
  }
}